var Application;

require('../../../core/frontend/vendor_modules/jquery-2.1.4.js');

require('../../../core/frontend/vendor_modules/cookie.js');

require('../../../core/frontend/vendor_modules/stub-underscore.js');

require('../../../core/frontend/vendor_modules/mailcheck-1.1.js');

Application = (function() {
  var NAMESPACES;

  NAMESPACES = ['Collections', 'Models', 'Views'];

  function Application(instance) {
    var registerNamespace, registerTopLevelNamespace;
    this.ExperimentVersions = {};
    registerTopLevelNamespace = (function(_this) {
      return function() {
        return _(NAMESPACES).each(function(ns) {
          return _this[ns] = {};
        });
      };
    })(this);
    registerNamespace = (function(_this) {
      return function(name) {
        return _(NAMESPACES).each(function(ns) {
          return _this[ns][name] = {};
        });
      };
    })(this);
    registerTopLevelNamespace();
    registerNamespace("Subscription");
    registerNamespace("Validate");
  }

  return Application;

})();

if (window.Groupon == null) {
  window.Groupon = {};
}

Groupon.SubscriptionApp = new Application();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MTU0OTM1MTMxODktODY0MS9wcm9kdWN0aW9uLTIwMTguMDEuMDlfMDkuNTEvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9ncm91cG9uL2Zyb250ZW5kL2dyb3Vwb24uY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvc3JhamVuZHJhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MTU0OTM1MTMxODktODY0MS9wcm9kdWN0aW9uLTIwMTguMDEuMDlfMDkuNTEvc3Vic2NyaXB0aW9uX2Zsb3cvbW9kdWxlcy9ncm91cG9uL2Zyb250ZW5kL2dyb3Vwb24uY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWVBLElBQUE7O0FBQUEsT0FBQSxDQUFRLHVEQUFSOztBQUNBLE9BQUEsQ0FBUSxpREFBUjs7QUFDQSxPQUFBLENBQVEsMERBQVI7O0FBQ0EsT0FBQSxDQUFRLHdEQUFSOztBQUdNO0FBRUosTUFBQTs7RUFBQSxVQUFBLEdBQWEsQ0FDWCxhQURXLEVBRVgsUUFGVyxFQUdYLE9BSFc7O0VBTUEscUJBQUMsUUFBRDtBQUNYLFFBQUE7SUFBQSxJQUFDLENBQUEsa0JBQUQsR0FBc0I7SUFFdEIseUJBQUEsR0FBNEIsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFBO2VBQzFCLENBQUEsQ0FBRSxVQUFGLENBQWEsQ0FBQyxJQUFkLENBQW1CLFNBQUMsRUFBRDtpQkFDakIsS0FBSyxDQUFBLEVBQUEsQ0FBTCxHQUFXO1FBRE0sQ0FBbkI7TUFEMEI7SUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBO0lBSTVCLGlCQUFBLEdBQW9CLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxJQUFEO2VBQ2xCLENBQUEsQ0FBRSxVQUFGLENBQWEsQ0FBQyxJQUFkLENBQW1CLFNBQUMsRUFBRDtpQkFDakIsS0FBSyxDQUFBLEVBQUEsQ0FBSSxDQUFBLElBQUEsQ0FBVCxHQUFpQjtRQURBLENBQW5CO01BRGtCO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQTtJQUlwQix5QkFBQSxDQUFBO0lBQ0EsaUJBQUEsQ0FBa0IsY0FBbEI7SUFDQSxpQkFBQSxDQUFrQixVQUFsQjtFQWJXOzs7Ozs7O0VBZ0JmLE1BQU0sQ0FBQyxVQUFXOzs7QUFFbEIsT0FBTyxDQUFDLGVBQVIsR0FBOEIsSUFBQSxXQUFBLENBQUEifQ==
